import { getPatients } from 'services/patients';
import { ListProvider } from 'contexts';
import { PatientsTable, PatientsHeader } from 'components';
import { useAuth } from '@contexts/AuthContext';

export const Patients = () => {
	const { user } = useAuth();
	const isAdmin = user?.isAdmin;
	const order = isAdmin ? {id: "codeOP", desc: true} : {id: "createdAt", desc: true}
	return (
		<ListProvider
			lastPageName='lastPagePatients'
			fetch={getPatients}
			orderBy={order}
		>
			<PatientsHeader />
			<PatientsTable />
		</ListProvider>
	);
};
